import formatDates from './format-dates';
import calculateDayOrDate from './calculate-day-or-date';
var pickupDayOrDate = function pickupDayOrDate(_ref) {
  var minPickupDate = _ref.minPickupDate,
    maxPickupDate = _ref.maxPickupDate,
    pickupTodayMessage = _ref.pickupTodayMessage,
    pickupTomorrowMessage = _ref.pickupTomorrowMessage,
    timeZone = _ref.timeZone;
  var maxDay = calculateDayOrDate(maxPickupDate);
  var minDay = calculateDayOrDate(minPickupDate);
  var _formatDates = formatDates({
      minDate: minPickupDate,
      maxDate: maxPickupDate,
      timeZone: timeZone
    }),
    formattedMaxDate = _formatDates.formattedMaxDate,
    formattedMinDate = _formatDates.formattedMinDate;

  // EDD Semantics for Shipping + Pickup on Cart & PDP
  // See https://confluence.nike.com/pages/viewpage.action?pageId=370409995
  var shouldShowToday = (minDay === null || minDay === void 0 ? void 0 : minDay.isToday) || (maxDay === null || maxDay === void 0 ? void 0 : maxDay.isToday);
  var shouldShowTomorrow = (minDay === null || minDay === void 0 ? void 0 : minDay.isTomorrow) || (maxDay === null || maxDay === void 0 ? void 0 : maxDay.isTomorrow);
  var hasEqualDates = formattedMaxDate && formattedMaxDate === formattedMinDate;
  var hasDateRange = maxPickupDate && minPickupDate && !hasEqualDates;
  var noMinDateButHasMaxDate = !minPickupDate && maxPickupDate;
  // BOPIS - The order will be available for pickup starting tomorrow at that store
  // Tomorrow at <store name>
  if (shouldShowTomorrow) {
    return pickupTomorrowMessage;
  }
  // BOPIS - The order will be available for pickup starting today at that store
  // Today at <store name>
  if (shouldShowToday) {
    return pickupTodayMessage;
  }
  // Ship to Store - The order will will be available for pickup starting October 8th at that store.
  // Thu, Oct 8 at <store name>
  if (hasEqualDates || noMinDateButHasMaxDate) {
    return formattedMinDate;
  }
  // Ship to Store - The order will be available for pickup sometime between October 8th and October 10th at that store.
  // Thu, Oct 8 - Sat, Oct 10 at <store name>
  if (hasDateRange) {
    return "".concat(formattedMinDate, " - ").concat(formattedMaxDate);
  }
  return null;
};
export default pickupDayOrDate;